<template>
  <v-container class="d-flex flex-column justify-center">
    <TopicSelector
      @topicsSelected="onTopicsSelected"
      v-show="!started"
    ></TopicSelector>
    <v-btn @click="onToggle" v-show="topics.length && !started" color="primary"
      >Start</v-btn
    >

    <v-card v-show="started">
      <v-container class="d-flex flex-column justify-center" v-show="started">
        <v-card-title>Quiz on {{ quizTitle }}</v-card-title>
        <v-card
          v-for="k in Object.keys(passages)"
          :key="k"
          outlined
          class="mb-4"
        >
          <v-card-text v-if="k !== 'default'">{{
            passageData[k].passage
          }}</v-card-text>
          <v-img
            v-if="passageData[k].imgUrl"
            :src="passageData[k].imgUrl"
          ></v-img>
          <v-card
            v-for="q in passages[k]"
            v-bind:key="q.question"
            class="mb-4 mx-2"
          >
            <v-img v-if="q.imgUrl" :src="q.imgUrl"></v-img>
            <v-card-text>{{ q.question }}</v-card-text>

            <v-radio-group v-model="q.userAnswer" class="ml-6 my-n3">
              <v-radio
                v-for="(a, index) in q.answers"
                :key="a"
                :label="a"
                :value="index"
                @change="onAnswer(q, index)"
              ></v-radio>
            </v-radio-group>
            <v-card-text v-show="q.userAnswer >= 0">{{
              q.isCorrect
            }}</v-card-text>
          </v-card>
        </v-card>
        <v-btn @click="onToggle" color="secondary">End</v-btn>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import topicsHierarchy from "../mixins/topicsHierarchy";
import TopicSelector from "./TopicSelector";
import firestoreUtils from "../mixins/firestoreUtils";
import passages from "../mixins/passages";
import questions from "../mixins/questions";

export default {
  name: "Quiz",
  components: { TopicSelector },
  mixins: [topicsHierarchy, firestoreUtils, passages, questions],
  data: () => ({
    topics: [],
    subtopics: [],
    passages: { default: [] },
    passageData: { default: {} },
    subtopicQuestions: { main: [] },
    started: false,
    selectedQuestions: []
  }),
  computed: {
    quizTitle() {
      return this.topics.join(", ");
    },
    allPassages() {
      return this.getPassages();
    },
    allQuestions() {
      return this.getQuestions();
    }
  },
  methods: {
    onTopicsSelected: function(topics) {
      this.topics = topics.selected;
      this.subtopics = topics.next;
      console.log(topics);
    },
    onToggle: function() {
      this.started = !this.started;
      if (!this.started) {
        this.selectedQuestions = [];
        this.passages = { default: [] };
        return;
      }
      this.selectedQuestions = this.allQuestions.filter(q => {
        if (this.topics.length == 1) {
          return q.primaryTopics.includes(this.topics[0]);
        }
        for (const topic of this.topics) {
          if (q.subtopics.includes(topic)) {
            return true;
          }
        }
      });
      this.orderQuestions();
      // console.log("selected qs", this.selectedQuestions);
    },
    onAnswer: function(question, answerIndex) {
      if (question.correctAnswer == answerIndex) {
        question.isCorrect = "Correct!\n" + question.explanation;
      } else {
        question.isCorrect = "Try again";
      }
    },
    orderQuestions: function() {
      //Two things - order by subcategory + order by passage
      // passage takes precedence
      // this whole thing will need to be rewritten
      // TODO : Right now there are no subcategories!!
      this.selectedQuestions.forEach(q => {
        //console.log("passage", q.passage);

        if (q.passage) {
          if (!this.passages[q.passage]) {
            this.passages[q.passage] = [];
            this.passageData[q.passage] = this.allPassages.filter(
              p => p.title == q.passage //this is a no-no. there's no language flow.
            )[0];
          }
          this.passages[q.passage].push(q);
        } else {
          this.passages.default.push(q);
        }
      });
    }
  }
};
</script>

<style scoped></style>
